import React from 'react';
import { Message, openButtonsModal } from '@weezevent/nacre';
import i18n from 'i18next';

export async function askUnpublish(cb) {
    return openButtonsModal({
        title: i18n.t('eventList.status.unpublishStatusModal.title'),
        details: (
            <Message type="warning" title={i18n.t('eventList.status.unpublishStatusModal.warningTitle')}>
                {i18n.t('eventList.status.unpublishStatusModal.warningText')}
            </Message>
        ),
        buttons: [
            {
                label: i18n.t('ticket.common.action.cancel')
            },
            {
                label: i18n.t('ticket.common.action.confirm'),
                primary: true,
                onClick: cb
            }
        ]
    });
}
